<div class="body">

    <app-select-issue-type [formControl]="valueControl" [appearance]="appearance"></app-select-issue-type>

    <div class="info">
        Vorgangstransaktionen sind typgebunden. Demnach soll es nicht möglich sein, dass beispielsweise eine Tickettransaktion auf einen Auftrag oder einen Change angewandt wird und ein Auftrag beispielsweise in einen Ticketstatus springt. Hierfür können Sie an dieser Stelle einen Typen wählen, für welchen entsprechende Status präsentiert werden.
    </div>

</div>
